import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-expansive-panel',
  templateUrl: './expansive-panel.component.html',
  styleUrls: ['./expansive-panel.component.scss']
})
export class ExpansivePanelComponent implements OnInit, OnChanges {

  @Input() title: string = '';
  @Input() isValid: boolean = false;
  @Input() expanded!: boolean;
  @Input() required: boolean = false;
  @Input() color: string = '#E4F2FC';
  @Input() checkbox: boolean = false;
  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;
  @Output() checkboxCheckedEvent = new EventEmitter<boolean>();

  panelExpanded: boolean = true

  ngOnInit(): void {
    if(this.expanded === undefined){
      this.expanded = true;
    }
  }

  toggleExpanded(): void {
    this.panelExpanded = !this.panelExpanded;
    this.checkboxCheckedEvent.emit(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['color']) {
      this.color = changes['color'].currentValue;
    }
    if (changes['checkbox']) {
      this.checkbox = changes['checkbox'].currentValue;
    }
  }

  checkedCheckbox(event: Event) {
    const value = (event.target as HTMLInputElement).checked;
    this.checkboxCheckedEvent.emit(value);
  }

}
